import React from "react";

const Header = () => {
    return (
        <div>
            <img src="../images/sunshinetradeexpo.jpg" alt="Sunshine1" width="600px"/>
        </div>
    )
}

export default Header;